



























































import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
  props: {}
})
export default class ReservationForm extends Vue {
  private valid = false;
  private nameRules = [
    (v: string) => !!v || "Zadajte meno",
    (v: string) => v.length <= 10 || "Meno musí mať menej než 10 znakov"
  ];
  private surnameRules = [
    (v: string) => !!v || "Zadajte priezvisko",
    (v: string) => v.length <= 10 || "Priezvisko musí mať menej než 10 znakov"
  ];
  private emailRules = [
    (v: string) => !!v || "Zadajte E-mail",
    (v: string) => /.+@.+\..+/.test(v) || "E-mail nie je platný"
  ];
  private phoneRules = [
    (v: string) => !!v || "Zadajte telefónne číslo",
    (v: string) => v.length < 14 || "Telefónne číslo nie je platné",
    (v: string) => v.length > 12 || "Telefónne číslo nie je platné",
    (v: string) => /^[+][0-9]*$/.test(v) || "Telefónne číslo nie je platné"
  ];
  private form = {
    customerPhoneNumber: "+421",
    customerName: "",
    customerSurname: "",
    customerMail: "",
    customerNote: ""
  };

  @Watch("valid")
  private validForm() {
    this.$emit("validForm", this.valid);
  }

  mounted() {
    this.$emit("form", this.form);
  }
}
